import { render, staticRenderFns } from "./words-progress.vue?vue&type=template&id=21612926&scoped=true&"
import script from "./words-progress.vue?vue&type=script&lang=js&"
export * from "./words-progress.vue?vue&type=script&lang=js&"
import style0 from "./words-progress.vue?vue&type=style&index=0&id=21612926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21612926",
  null
  
)

export default component.exports